export default "__VITE_ASSET__DvzWrtLS__"